import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useMedia } from 'react-use';
import { Button, Typography, LazyLoadImage } from 'ck-ui';
import { getSanityImg } from 'src/sanityClient';
import { getPromoName, trackPromotionClick } from '../utils';
import { usePromotionView } from '../hooks';

const Grid = ({ blockGrid, handle, position }) => {
  const isMobile = useMedia('(max-width: 767px)');
  const ref = React.useRef(null);
  const { header: title, backgroundColour, flexBlock } = blockGrid;

  usePromotionView(flexBlock.map((item, index) => ({
    id: handle,
    name: getPromoName(handle, item.trackingID || item.title || item.url || `${title}-${position}-${index}`),
    creative: getSanityImg(isMobile ? (item.mobileImage || item.desktopImage) : item.desktopImage).url(),
    position: `${handle}-${position}-${index}`
  })), ref);

  return (
    <section
      className={classnames('home-section', { 'home-section-hasbackground': backgroundColour })}
      style={{ backgroundColor: backgroundColour }}
      ref={ref}
    >
      <div className={classnames('container')}>
        {(title) && (
          <div className="home-section-header">
            {title && <h2 className="heading5 is-uppercase">{title}</h2>}
          </div>
        )}
        <div className="columns">
          {flexBlock.map((item, index) => {
            const imgUrl = getSanityImg(isMobile ? (item.mobileImage || item.desktopImage) : item.desktopImage).url();

            return (
              <div
                role="link"
                tabIndex="0"
                key={item._key}
                className="column home-grid-column"
                onClick={() => trackPromotionClick({
                  id: handle,
                  name: getPromoName(handle, item.trackingID || item.title || item.url || `${title}-${position}-${index}`),
                  position: `${handle}-${position}-${index}`
                })}
              >
                <a href={item.url} className="banner-link" title={item.title}>
                  <div
                    className="image-wrapper no-border"
                    style={{
                      paddingBottom: !isMobile
                        ? `calc(${item.desktopImage.height / item.desktopImage.width} * 100%)`
                        : `calc(${item.mobileImage.height / item.mobileImage.width} * 100%)` }}
                  >
                    <LazyLoadImage
                      src={imgUrl}
                      alt={item.title}
                    />
                  </div>
                </a>
                <div className="home-grid-text-section  no-border align-center">
                  <a title={item.title} href={item.url} className="banner-link">
                    <Typography variant="heading3" uppercase>{item.title}</Typography>
                    <Typography
                      renderAs="p"
                      className="grid-margin-top"
                      variant={isMobile ? 'body-medium' : 'body-large'}
                    >{item.content}
                    </Typography>
                  </a>
                  <Button
                    renderAs="a"
                    href={item.url}
                    size={isMobile ? 'medium' : 'large'}
                    className="grid-margin-top"
                    title={item.title}
                  >{item.buttonText}
                  </Button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

Grid.propTypes = {
  blockGrid: PropTypes.object.isRequired,
  handle: PropTypes.string.isRequired,
  position: PropTypes.number.isRequired,
};

export { Grid };
